<template>
    <div class="mt-5">
        <p class="text-center text-2xl font-bold font-poppins">
            Antrian Pendaftaran Pasien Poliklinik
        </p>
    </div>
    <div class="flex justify-center flex-col md:flex-row">
        <div
            class="rounded-lg p-5 mt-3 font-poppins text-center w-72 flex flex-col justify-center items-center bg-primary text-white font-bold md:mr-2"
        >
            <div class="w-full border-b-4 border-gray-300 pb-3">
                <p class="text-center">PENDAFTARAN ONLINE</p>
            </div>
            <div class="w-full mt-2 mb-2 border-b-4 border-gray-300 pb-4">
                <p class="text-center">TOTAL ANTRIAN</p>
                <p class="text-center">{{antrianTotalData.totalAntrian.online}}</p>
            </div>
            <hr />
            <div class="w-full pb-3">
                <p class="text-center">JUMLAH TERLAYANI</p>
                <p class="text-center">{{antrianTotalData.jumlahTerlayani.online}}</p>
            </div>
        </div>
        <div
            class="rounded-lg p-5 mt-3 font-poppins text-center w-72 flex flex-col justify-center items-center bg-primary text-white font-bold"
        >
            <div class="w-full border-b-4 border-gray-300 pb-3">
                <p class="text-center">PENDAFTARAN OFFLINE</p>
            </div>
            <div class="w-full mt-2 mb-2 border-b-4 border-gray-300 pb-4">
                <p class="text-center">TOTAL ANTRIAN</p>
                <p class="text-center">{{antrianTotalData.totalAntrian.offline}}</p>
            </div>
            <hr />
            <div class="w-full pb-3">
                <p class="text-center">JUMLAH TERLAYANI</p>
                <p class="text-center">{{antrianTotalData.jumlahTerlayani.offline}}</p>
            </div>
        </div>
    </div>
    <div class="mt-5">
        <p class="text-center text-2xl font-bold font-poppins">
            Antrian Pendaftaran Pasien Berdasarkan Jaminan
        </p>
    </div>
    <div class="flex justify-center flex-col md:flex-row">
        <div
            class="rounded-lg p-5 mt-3 font-poppins text-center w-72 flex flex-col justify-center items-center bg-primary text-white font-bold"
        >
            <div class="w-full border-b-4 border-gray-300 pb-3">
                <p class="text-center">BPJS</p>
            </div>
            <div class="w-full mt-2 mb-2 border-b-4 border-gray-300 pb-4">
                <p class="text-center">TOTAL ANTRIAN</p>
                <p class="text-center">{{antrianTotalData.totalAntrian.bpjs}}</p>
            </div>
            <hr />
            <div class="w-full pb-3">
                <p class="text-center">JUMLAH TERLAYANI</p>
                <p class="text-center">{{antrianTotalData.jumlahTerlayani.bpjs}}</p>
            </div>
        </div>
        <div
            class="rounded-lg p-5 mt-3 font-poppins text-center w-72 flex flex-col justify-center items-center bg-primary text-white font-bold md:mx-2"
        >
            <div class="w-full border-b-4 border-gray-300 pb-3">
                <p class="text-center">UMUM</p>
            </div>
            <div class="w-full mt-2 mb-2 border-b-4 border-gray-300 pb-4">
                <p class="text-center">TOTAL ANTRIAN</p>
                <p class="text-center">{{antrianTotalData.totalAntrian.umum}}</p>
            </div>
            <hr />
            <div class="w-full pb-3">
                <p class="text-center">JUMLAH TERLAYANI</p>
                <p class="text-center">{{antrianTotalData.jumlahTerlayani.umum}}</p>
            </div>
        </div>
        <div
            class="rounded-lg p-5 mt-3 font-poppins text-center w-72 flex flex-col justify-center items-center bg-primary text-white font-bold"
        >
            <div class="w-full border-b-4 border-gray-300 pb-3">
                <p class="text-center">LAINNYA</p>
            </div>
            <div class="w-full mt-2 mb-2 border-b-4 border-gray-300 pb-4">
                <p class="text-center">TOTAL ANTRIAN</p>
                <p class="text-center">{{antrianTotalData.totalAntrian.lainnya}}</p>
            </div>
            <hr />
            <div class="w-full pb-3">
                <p class="text-center">JUMLAH TERLAYANI</p>
                <p class="text-center">{{antrianTotalData.jumlahTerlayani.lainnya}}</p>
            </div>
        </div>
    </div>
    <div class="mt-5">
        <p class="text-center text-2xl font-bold font-poppins">
            DATA PER {{antrianTotalData.data_per}}
        </p>
    </div>
    <div class="font-poppins mt-5">
        <p class="font-sm text-center">
            JUMLAH TOTAL PENDAFTAR : {{ antrianTotalData.total.pendaftar }}, <br/>JUMLAH TERLAYANI : {{antrianTotalData.total.terlayani}}
        </p>
    </div>
    <div class="font-poppins mt-5">
        <p class="font-sm">
            data diperbaharui pada :
            <span class="text-red-500">{{ timerCount }}</span>
        </p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            timerCount: 10,
            antrianTotalData: this.antrianTotal,
        };
    },
    methods: {
        getAntrianTotal() {
            this.$inertia.get(
                "/antrian_total/ajax",
                {},
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.antrianTotalData =
                            page.props.additional.antrianTotal;
                        this.timerCount = 10;
                    },
                }
            );
        },
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                } else {
                    this.getAntrianTotal();
                }
            },
            immediate: true,
        },
    },
    props: {
        antrianTotal: Object
    },
};
</script>
